var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-primary-forward-icon',{attrs:{"text":_vm.title,"subText":_vm.buttonCountText},on:{"click":_vm.navigate}},[_c('icon-cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }